import ApiService from '@/services/api.service';

const MedicationService = {
    getAll(parameter, addExtraParams = false) {
        const params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            PatientCode: parameter.PatientCode,
            Status: parameter.Status
        };

        if (addExtraParams) {
            // Add extra params , only for report listing
            params.DrugCodeList = parameter.DrugCodeList;
            params.PatientCodeList = parameter.PatientCodeList;
            params.ActiveAdmission = parameter.IsActiveAdmission;
            params.PatientIsActive = parameter.IsActive;
            params.DateFrom = parameter.DateFrom;
            params.DateTo = parameter.DateTo;
            params.PrescriberCodeList = parameter.PrescriberCodeList;

            return ApiService.getWithArray('/PatientMedications/ListRep', params);
        }

        const requestData = {
            method: 'get',
            url: '/PatientMedications/',
            headers: {},
            params: params
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientMedications/${id}`);
    },

    getInfoFDB(DrugCode,PatientCode) {
        const requestData = {
            method: 'get',
            url: '/PatientMedications/DrugInfoFDB/',
            headers: {},
            params: {
                DrugCode: DrugCode,
                PatientCode: PatientCode
            }
        };
        return ApiService.customRequest(requestData);
    },


    getPrescribers() {
        return ApiService.get(`/PatientMedications/Prescribers`);
    },

    getMedFreq() {
        return ApiService.get(`/VW_MdDrugFreqSetupHdrOnlyAdministrations`);
    },
    getMedIndications() {
        return ApiService.get(`/MdRxIndications`);
    },

    add(data) {
        return ApiService.post(`/PatientMedications`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientMedications/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientMedications/${id}`, data);
    },

    getMarsTimes(Freq, Dosage, DailyAmount) {
        return ApiService.get(
            `/PatientMedications/MarsTime?FrequencyCode=${Freq}&Dosage=${Dosage}&DailyAmount=${DailyAmount}`
        );
    },

    getDrugInfo(DrugCode, FreqCode, DailyAmount, SDTime, EDTime) {
        return ApiService.get(
            `/PatientMedications/DrugInfo?DrugCode=${DrugCode}&FrequencyCode=${FreqCode}&DailyAmount=${DailyAmount}&StartDateTime=${SDTime}&EndDateTime=${EDTime}`
        );
    },

    getQuantityToOrder(parameter) {
        const params = {
            DrugCode: parameter.DrugCode,
            FrequencyCode: parameter.FreqCode,
            DailyAmount: parameter.DailyAmount,
            StartDateTime: parameter.SDTime,
            EndDateTime: parameter.EDTime,
            Day: parameter.Day,
            MarsAdminTime: parameter.MarsAdminTime,
            MarsDosage: parameter.MarsDosage
        };
        return ApiService.getWithArray('/PatientMedications/QuantityToOrder', params);
    },

    getDrugFrequencyByCode(code) {
        return ApiService.get(`/DrugFrequencyHeaders/${code}`);
    },

    getSig(parameter) {
        const params = {
            DrugCode: parameter.DrugCode,
            FrequencyCode: parameter.FreqCode,
            Day: parameter.Day,
            Dosage: parameter.Dosage,
            DailyAmount: parameter.DailyAmount,
            Action: parameter.Action,
            Route: parameter.Route,
            WhenSig: parameter.WhenSig,
            Reason: parameter.Reason,
            MarsAdminTime: parameter.MarsAdminTime,
            MarsDosage: parameter.MarsDosage
        };
        return ApiService.getWithArray('/PatientMedications/Sig', params);
    },

    CopyOrdeer(data) {
        return ApiService.post(`/PatientMedications/CopyOrdeer`, data);
    },

    InactiveOrders(data) {
        return ApiService.post(`/PatientMedications/InactiveOrders`, data);
    },

    IsPrescriptionCurrent(parameter) {
        const params = {
            PatientCode: parameter.PatientCode,
            DrugCode: parameter.DrugCode,
            Mode: parameter.Mode,
            RecordId: parameter.RecordId,
            Action: parameter.Action,
            StartDateTime: parameter.StartDateTime,
            EndDateTime: parameter.EndDateTime,
            Day: parameter.Day
        };
        return ApiService.getWithArray('/PatientMedications/IsPrescriptionCurrent', params);
    },
    getDrugs() {
        return ApiService.get(`/PatientMedications/AllDrugs?`);
    },

    getUrlMerative() {
        return ApiService.get(`/PatientMedications/GetAssistantUrl`);
    },

   getUrlDrugInfo(Code) {
    const url = Code && Code.trim()
        ? `/PatientMedications/GetDrugInfoUrl?DrugCode=${Code}`
        : `/PatientMedications/GetDrugInfoUrl`;
        return ApiService.get(url);
    },

    getStandingOrders(parameter) {
        const requestData = {
            method: 'get',
            url: '/StandingOrderHdrs/',
            headers: {},
            params: {
                SearchCriteria: parameter.SearchCriteria,
                Active: parameter.Active,
                OrderBy: parameter.OrderBy,
                Code: parameter.code,
                LoadDetails: parameter.loadDetails
            }
        };
        return ApiService.customRequest(requestData);
    },

    getStandingOrderDrugs(parameter) {
        return ApiService.getWithArray('/PatientMedications/StandingOrderDrugs', parameter);
    },

    getStandingOrderDrugsPrescription(parameter) {
        return ApiService.getWithArray(
            '/PatientMedications/StandingOrderDrugs/Prescription',
            parameter
        );
    },

    addStandingOrders(parameter) {
        return ApiService.post(`/PatientMedications/StandingOrders`, parameter);
    },

    updateNotes(recordId, comments) {
        return ApiService.put(`/PatientMedications/Notes/${recordId}`, comments);
    },

    getNotes(recordId) {
        return ApiService.get(`/PatientMedications/Notes/${recordId}`);
    },

    addProtocolSetup(data) {
        return ApiService.post(`/StandingOrderHdrs`, data);
    },

    deleteProtocolSetup(id) {
        return ApiService.delete(`/StandingOrderHdrs/${id}`);
    },

    updateProtocolSetup(id, data) {
        return ApiService.put(`/StandingOrderHdrs/${id}`, data);
    },

    getProtocolSetupByCode(parameter) {
        const requestData = {
            method: 'get',
            url: '/StandingOrderHdrs/',
            headers: {},
            params: {
                code: parameter.code
            }
        };
        return ApiService.customRequest(requestData);
    }
};

export default MedicationService;
